// extracted by mini-css-extract-plugin
module.exports = {"product":"_1ziI4i","link":"k6uawW","image":"ZKDdJ8","text":"_2ZNstw","brand":"_3qx8-5","addButton":"_1_ookp"};